const ALLOWED_LANGUAGE_CODES = ['es', 'pt_BR', 'en'];

export const filterAllowedLanguageOptions = languageOptions => {
  const optionsByCode = new Map(
    (languageOptions || []).map(option => [option.iso_639_1_code, option])
  );

  return ALLOWED_LANGUAGE_CODES.map(code => optionsByCode.get(code)).filter(
    Boolean
  );
};

export { ALLOWED_LANGUAGE_CODES };
